import { Resource } from '@/clients/utoniq-core/schema'

import { VoiceDRMPlayer } from './VoiceDRMPlayer'
import { VoicePurePlayer } from './VoicePurePlayer'
export { SelectableVoicePlayer } from './SelectableVoicePlayer'

type Props = {
  resource: Resource
  bgcolor?: string
  color?: string
}

export const VoicePlayer = ({ resource, bgcolor, color }: Props) => {
  if (resource.drm?.encryptingStatus === 'encrypted') {
    return (
      <VoiceDRMPlayer resource={resource} bgcolor={bgcolor} color={color} />
    )
  }

  return (
    <VoicePurePlayer
      uri={resource.smallUri || ''}
      bgcolor={bgcolor}
      color={color}
    />
  )
}
